









































import { defineComponent, onMounted, watch, ref, computed } from '@vue/composition-api';
import { createPopper } from '@popperjs/core';
import { CreationLevel } from '@tt4b/ttam-enums';
import { i18n } from './../../../../i18n';
import { useQueryFrequencyWithValueControlApi, signFrequencyWithValueControl } from '@tt4b/ttam-hooks';

const NewTutorialCopyGif =
  'https://lf19-ttmp.tiktokstaticb.com/obj/ttastatic-sg/new-user-tutorial/1nn-new-tutorial-copy.gif';
const NewTutorialCreateGif =
  'https://lf19-ttmp.tiktokstaticb.com/obj/ttastatic-sg/new-user-tutorial/1nn-new-tutorial-create.gif';
const name = 'new-user-tutorial';
const FREQUENCY_VALUE = {
  ERROR: 0,
  DEFAULT: 1,
  HAS_CLICK: 4, // 使用过侧边拦传4
};
const MAX_COUNT = 3;

export default defineComponent({
  name,
  props: {
    curUid: {
      type: String,
      default: '',
    },
    curLevel: {
      type: String,
      default: '',
    },
    isCreate: {
      type: Boolean,
      default: false,
    },
    settingType: {
      type: Number,
      default: 0,
    },
    settingDimension: {
      type: Number,
      default: 0,
    },
    adgroupNum: {
      type: Number,
      default: 0,
    },
  },
  setup(props, { emit }) {
    const isShow = ref(false);
    let newTutorialCount = ref(FREQUENCY_VALUE.DEFAULT);
    let instance = null;
    const newTutorialGif = computed(() => (props.isCreate ? NewTutorialCreateGif : NewTutorialCopyGif));

    function checkIsInViewPort(element) {
      const viewWidth = window.innerWidth || document.documentElement.clientWidth;
      const viewHeight = window.innerHeight || document.documentElement.clientHeight;
      const { top, right, bottom, left } = element.getBoundingClientRect();

      return top >= 0 && left >= 0 && right <= viewWidth && bottom <= viewHeight;
    }

    function getReferenceDom() {
      if (props.curLevel === CreationLevel.CAMPAIGN) {
        return document.querySelector(`#ttam-sidebar-campaign-node_${props.curUid}`);
      }

      if (props.curLevel === CreationLevel.ADGROUP) {
        return document.querySelector(`#ttam-sidebar-adgroup-level-node_${props.curUid}`);
      }
      if (props.curLevel === CreationLevel.CREATIVE) {
        return document.querySelector(`#ttam-sidebar-creative-node_${props.curUid}`);
      }
    }

    function getNewUserTutorialConfig(isCreate: boolean) {
      if (isCreate) {
        return {
          title: i18n.t('1nn_new_user_tutorial_title'),
          detail: [
            i18n.t('1nn_new_user_tutorial_content_one'),
            i18n.t('1nn_new_user_tutorial_content_two'),
            i18n.t('1nn_new_user_tutorial_content_three'),
          ],
        };
      }
      return {
        title: i18n.t('1nn_new_user_tutorial_title_copy'),
        detail: [i18n.t('1nn_new_user_tutorial_content_one_copy'), i18n.t('1nn_new_user_tutorial_content_two_copy')],
      };
    }

    const signValue = (hasClick?: boolean) => {
      if (newTutorialCount.value === FREQUENCY_VALUE.ERROR) {
        return;
      }
      // 新建场景，未展示过Nux，操作侧边栏，不标记为已展示过
      if (
        props.isCreate &&
        newTutorialCount.value === FREQUENCY_VALUE.DEFAULT &&
        hasClick &&
        props.curLevel === CreationLevel.CAMPAIGN
      ) {
        return;
      }
      let controlValue = FREQUENCY_VALUE.HAS_CLICK;
      if (!hasClick) {
        controlValue = newTutorialCount.value + 1;
      }
      signFrequencyWithValueControl({
        setting_type: props.settingType,
        setting_dimension: props.settingDimension,
        value: controlValue,
      }).then(() => {
        newTutorialCount.value = controlValue;
      });
    };

    function handleClickGotIt() {
      isShow.value = false;
    }

    function initPopper() {
      let timerCount = 0;
      if (instance || newTutorialCount.value > MAX_COUNT) {
        return;
      }
      const timer = setInterval(() => {
        let referenceDom = getReferenceDom();
        ++timerCount;
        if (referenceDom) {
          // 当前高亮项不在可视区域内，则定位在侧边栏最下方
          const isInViewPort = checkIsInViewPort(referenceDom);
          if (!isInViewPort) {
            const _referenceDom = document.querySelector(`.ttam-creation-sidebar`);
            if (!_referenceDom) {
              return;
            }
            referenceDom = _referenceDom;
          }

          isShow.value = true;
          signValue();
          instance = createPopper(referenceDom, document.querySelector('#new-user-tutorial'), {
            placement: isInViewPort ? 'right-start' : 'right-end',
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 18],
                },
              },
              {
                name: 'eventListeners',
                enabled: false,
              },
            ],
          });
          clearInterval(timer);
        } else if (timerCount === 10) {
          clearInterval(timer);
        }
      }, 1000);
    }

    function destroyPopper() {
      isShow.value = false;
      instance?.destroy();
      instance = null;
    }

    function subscribeWatch() {
      watch(
        () => [props.curLevel, props.adgroupNum],
        newVal => {
          if (newTutorialCount.value === FREQUENCY_VALUE.ERROR) {
            return;
          }

          const [curLevel, adgroupNum] = newVal;
          if (![CreationLevel.CAMPAIGN, CreationLevel.ADGROUP, CreationLevel.CREATIVE].includes(curLevel)) {
            return;
          }

          if (props.isCreate) {
            // 新建场景，adgroup清空，Nux消失
            if (curLevel === CreationLevel.CAMPAIGN && !adgroupNum) {
              destroyPopper();
            }
            if ([CreationLevel.ADGROUP, CreationLevel.CREATIVE].includes(curLevel) && adgroupNum) {
              initPopper();
            }
          } else {
            initPopper();
          }
        },
      );
    }

    function init() {
      useQueryFrequencyWithValueControlApi({
        setting_type: props.settingType,
        setting_dimension: props.settingDimension,
      })
        .then(result => {
          newTutorialCount.value = result.value || FREQUENCY_VALUE.DEFAULT;
          subscribeWatch();

          if (!props.isCreate) {
            initPopper();
          }
        })
        .catch(() => {
          newTutorialCount.value = FREQUENCY_VALUE.ERROR;
        });
    }

    init();

    return {
      name,
      isShow,
      newUserTutorialConfig: getNewUserTutorialConfig(props.isCreate),
      handleClickGotIt,
      signValue,
      newTutorialGif,
    };
  },
});
